// Rough world outline as [lon, lat] polygons, turned into a grid of dots for the "Who uses it" slide.
// Decorative only: good enough to read as a world map, not a survey-grade one.
type Pt = [number, number];
const POLYS: Pt[][] = [
  [[-168,66],[-140,70],[-120,72],[-95,72],[-80,70],[-62,60],[-55,50],[-67,45],[-76,38],[-81,30],[-80,25],[-90,29],[-97,26],[-97,20],[-92,18],[-87,21],[-83,15],[-77,8],[-80,7],[-86,11],[-93,15],[-105,20],[-110,24],[-112,30],[-118,34],[-124,42],[-130,52],[-150,60],[-165,60]],
  [[-55,60],[-45,60],[-20,70],[-20,82],[-60,82],[-72,76]],
  [[-80,8],[-62,10],[-50,0],[-35,-6],[-40,-22],[-48,-28],[-58,-38],[-65,-55],[-72,-52],[-74,-40],[-71,-20],[-81,-6]],
  [[-10,36],[-9,43],[-1,46],[-5,48],[2,51],[8,54],[5,58],[10,63],[20,70],[30,71],[60,70],[80,73],[105,78],[140,72],[170,70],[180,66],[160,60],[155,50],[142,46],[135,35],[128,36],[122,40],[122,30],[110,20],[106,10],[100,2],[98,15],[92,22],[80,8],[73,20],[66,25],[57,25],[52,16],[43,13],[35,28],[35,36],[27,37],[26,40],[23,36],[18,40],[12,44],[15,38],[8,44],[3,43],[0,38]],
  [[-17,21],[-10,35],[10,37],[32,31],[34,28],[43,12],[51,12],[40,-5],[40,-15],[35,-25],[20,-35],[12,-17],[9,-1],[8,4],[-8,4],[-17,14]],
  [[113,-22],[130,-12],[142,-11],[153,-25],[148,-38],[135,-35],[115,-34]],
  [[-6,50],[2,51],[0,58],[-6,58]],
  [[130,31],[141,36],[145,44],[140,41]],
  [[95,5],[105,-6],[120,-9],[140,-8],[130,0],[110,2]],
];
const CITIES: Pt[] = [[-74,41],[0,51],[73,19],[3,6],[-46,-23],[151,-34],[104,1],[55,25],[-79,43],[121,15],[-100,19],[30,-26],[139,35],[37,56]];

export const MAP_W = 200;
export const MAP_H = 96;
const project = (lon: number, lat: number): Pt => [((lon + 180) / 360) * MAP_W, ((78 - lat) / 136) * MAP_H];

function inside(x: number, y: number, p: Pt[]): boolean {
  let c = false;
  for (let i = 0, n = p.length; i < n; i++) {
    const [x1, y1] = p[i], [x2, y2] = p[(i + 1) % n];
    if (y1 > y !== y2 > y && x < ((x2 - x1) * (y - y1)) / (y2 - y1) + x1) c = !c;
  }
  return c;
}

let cache: { dots: Pt[]; cities: Pt[] } | null = null;
export function worldDots(): { dots: Pt[]; cities: Pt[] } {
  if (cache) return cache;
  const step = 2.1, lonStep = (step / MAP_W) * 360, latStep = (step / MAP_H) * 136;
  const dots: Pt[] = [];
  for (let lat = 76; lat > -58; lat -= latStep)
    for (let lon = -178; lon < 180; lon += lonStep)
      if (POLYS.some(p => inside(lon, lat, p))) {
        const [x, y] = project(lon, lat);
        dots.push([Math.round(x * 10) / 10, Math.round(y * 10) / 10]);
      }
  cache = { dots, cities: CITIES.map(([a, b]) => project(a, b)) };
  return cache;
}
